export function parsePercent(curr = 0, total = 0) {
  // finding percentage
  return (curr / 10) * (total / 10);
}

// child = 75, parent = 37
export function handleCompPerformance(child = 0, parent = 0) {
  const diff = Math.abs(child - parent);
  if (child > parent && diff >= 25) {
    return "double_increase";
  } else if (child > parent && diff < 25) {
    return "increase";
  } else if (parseFloat(child).toFixed(2) == parseFloat(parent).toFixed(2)) {
    return "equal";
  } else if (parent > child && diff < 25) {
    return "decrease";
  } else if (parent > child && diff >= 25) {
    return "decrease_double";
  } else {
    console.error("something went wrong", child, parent);
    return null;
  }
}

export const getQueryStringParams = query => {
  return query
      ? (/^[?#]/.test(query) ? query.slice(1) : query)
          .split('&')
          .reduce((params, param) => {
                  let [key, value] = param.split('=');
                  params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
                  return params;
              }, {}
          )
      : {}
};